module.exports = __webpack_public_path__ + "img/bitcoin-alternative2.0bfa7665.png";